import React from 'react'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DeleteProductTypeProp } from '../types/making.type';

const DeleteProductType: React.FC<DeleteProductTypeProp> = ({ isDeleteProductTypeOpen, selectedId, reloadDataSource, onClose }) => {
    return (
        <>
            <Modal
                show={isDeleteProductTypeOpen}
                onHide={() => {
                    onClose();
                }
                }
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-break">
                    Are you sure you want to delete&nbsp;
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="customer-name-tooltip">
                            </Tooltip>
                        }
                    >
                        <strong
                            className="d-inline-block text-truncate"
                            style={{ maxWidth: "250px", verticalAlign: "bottom" }}
                        >
                        </strong>
                    </OverlayTrigger>
                    &nbsp;customer?
                </Modal.Body>


                <Modal.Footer>
                    <Button
                        variant="btn add-btn"
                        onClick={() => onClose()}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="btn submit-btn"
                    // disabled={loading}
                    >
                        {false ? "Deleting..." : "Delete"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DeleteProductType
